import Vue from 'vue';
import Vuex from 'vuex';
// import vuexAlong from 'vuex-along';
Vue.use(Vuex);
const state = {
  status: "",
  searchStatus: "",
  newShopMemberId: '',
  count: 1,
  shopInformation: '',
  scanSwitch:false,//收银开单扫码枪录入开关
  commidityList: [], //商品数组
  saleUserId: '', //选中的销售员id
  cartList: [], //收银开单购物车列表
  takeOutCartList: [], //收银开单取出的单
  cartListTotalPrice: 0.00, //收银开单购物车总价
  memberPriceTotal: 0, //购物车会员价商品总价
  cartListDiscounts: 0.00, //收银开单购物车优惠价格
  goodsMonads: [], //取单数组
  offers: {
    type: 0, //1:优惠券 2:整单改价 3：整单折扣 4：会员卡
    discountNumber: 0, //折扣数量
    reducePrice: 0, //改价金额
    cashCoupon: [], //优惠券信息
    vipIfm: [],
    vipIfms: {
      fullName: "",
      cardName: "",
      discount: "",
      wallet: ""
    }
  }, //优惠信息
  list: []
}
const mutations = {
  //清除优惠信息
  clearOffers() {
    state.offers = {
      type: 0, //1:优惠券 2:整单减免金额 3：整单折扣 4：会员卡
      discountNumber: 0, //折扣数量
      reducePrice: 0, //改价金额
      cashCoupon: [], //优惠券信息
      vipIfm: [],
      vipIfms: {
        fullName: "",
        cardName: "",
        discount: "",
        wallet: ""
      }
    } //优惠信息
  },
  //清除购物车
  clearCartList() {
    state.cartList = [];
    state.cartList = [];
    state.offers = {
      type: 0, //1:优惠券 2:整单减免金额 3：整单折扣 4：会员卡
      discountNumber: 0, //折扣数量
      reducePrice: 0, //改价金额
      cashCoupon: [], //优惠券信息
      vipIfm: [],
      vipIfms: {
        fullName: "",
        cardName: "",
        discount: "",
        wallet: ""
      }
    } //优惠信息
  },
  //计算总价
  countTotalPrice(state) {
    // console.log('计算总价')
    var cartListTotalPrice = 0
    var memberPriceTotal = 0
    for (let a of state.cartList) {
      cartListTotalPrice += a.goodsNum * a.retailPrice
      if (a.memberPrice) {
        memberPriceTotal += a.goodsNum * a.memberPrice
      } else {
        memberPriceTotal += a.goodsNum * a.retailPrice
      } 
    }
    state.cartListTotalPrice = cartListTotalPrice.toFixed(2)
    state.memberPriceTotal = memberPriceTotal
  },
  //计算优惠价格
  countCartListPrice(state) {
    var price = state.cartListTotalPrice
    var offers = state.offers
    if (offers.type == 1) {
      if (price > offers.cashCoupon.minUsePrice || price == offers.cashCoupon.minUsePrice) {
        price = (price - offers.cashCoupon.price).toFixed(2)
        state.cartListDiscounts = offers.cashCoupon.price.toFixed(2)
        state.cartListTotalPrice = Number(price).toFixed(2)
      } else {
        state.cartListDiscounts = 0.00
      }

    } else if (offers.type == 2) {
      state.cartListDiscounts = state.cartListTotalPrice - Number(offers.reducePrice)
      state.cartListTotalPrice = Number(offers.reducePrice).toFixed(2)

    } else if (offers.type == 3) {
      console.log(state.cartList, "购物车")
      var cartListTotalPrice9 = 0
      var res = state.cartList.filter(item => {
        cartListTotalPrice9 += item.goodsNum * item.retailPrice
        return item.retailPrice == 0.01
      })
      console.log(res, "数量乘单价乘折扣等于0.01或0.00的数组")
      console.log(cartListTotalPrice9, "cartListTotalPrice9")
      var memberPriceTotal = 0
      if (res.length == 0) {
        state.cartList.forEach(a => {
          memberPriceTotal += (a.retailPrice * (Number(state.offers.discountNumber) / 10)).toFixed(2) * a.goodsNum
        })
        state.cartListDiscounts = cartListTotalPrice9 - memberPriceTotal
        state.cartListTotalPrice = memberPriceTotal
        return
      }
      var cartListTotalPrice2 = 0
      var cartListTotalPrice1 = 0
      var list = []
      list = state.cartList.filter(item1 => {
        return item1.retailPrice !== 0.01
      })
      console.log(list, "数量乘单价乘折扣不等于0.01或0.00的数组")
      for (var i in res) {
        cartListTotalPrice2 += res[i].retailPrice * Number(res[i].goodsNum)
      }
      list.forEach(item => {
        cartListTotalPrice1 += (item.retailPrice * Number(state.offers.discountNumber) / 10).toFixed(2) * Number(item.goodsNum)
      })
      console.log(cartListTotalPrice1, "cartListTotalPrice1")
      console.log(cartListTotalPrice2, "cartListTotalPrice2")
      state.cartListTotalPrice = (cartListTotalPrice1 + cartListTotalPrice2).toFixed(2)
      state.cartListDiscounts = (cartListTotalPrice9 - state.cartListTotalPrice).toFixed(2)

    } else if (offers.type == 4) {

      console.log(state.cartList, "购物车")
      var cartListTotalPrice9 = 0
      var res = state.cartList.filter(item => {
        cartListTotalPrice9 += item.goodsNum * item.retailPrice
        if (item.memberPrice) {
          return item.memberPrice == 0.01
        } else {
          if (item.retailPrice == 0.01) {
            return item.retailPrice == 0.01
          }
        }
      })
      console.log(res, "数量乘单价乘折扣等于0.01或0.00的数组")
      if (res.length == 0) {
        var memberPriceTotal = 0
        var memberPriceTotal1 = 0
        var memberPriceTotal2 = 0
        state.cartList.forEach(a => {
          if (a.memberPrice) {
            memberPriceTotal1 += a.goodsNum * (a.memberPrice * Number(state.offers.vipIfm.discount)).toFixed(2)
            memberPriceTotal += a.goodsNum * (a.memberPrice * Number(state.offers.vipIfm.discount)).toFixed(2)
          } else {
            memberPriceTotal2 += a.goodsNum * (a.retailPrice * Number(state.offers.vipIfm.discount)).toFixed(2)
            memberPriceTotal += a.goodsNum * (a.retailPrice * Number(state.offers.vipIfm.discount)).toFixed(2)
          } 
        })
        console.log(memberPriceTotal1, memberPriceTotal2, memberPriceTotal, "memberPriceTotal")
        state.cartListTotalPrice = (memberPriceTotal1 + memberPriceTotal2).toFixed(2)
        state.cartListDiscounts = (cartListTotalPrice9 - state.cartListTotalPrice).toFixed(2)
        return
      }
      var cartListTotalPrice2 = 0
      var cartListTotalPrice1 = 0
      var cartListTotalPrice3 = 0
      var price3 = 0
      var price4 = 0
      var list = []
      list = state.cartList.filter(item1 => {
        if (item1.memberPrice) {
          return item1.memberPrice !== 0.01
        } else {
          if (item1.retailPrice !== 0.01) {
            return item1.retailPrice !== 0.01
          }
        }
      })
      var price1 = 0
      var price2 = 0
      var price5 = 0
      var price6 = 0
      for (var k in list) {
        if (list[k].memberPrice) {
          price1 += (list[k].memberPrice * Number(state.offers.vipIfm.discount)).toFixed(2) * Number(list[k].goodsNum)
          price5 += list[k].memberPrice * Number(list[k].goodsNum)
        } else {
          price2 += (list[k].retailPrice * Number(state.offers.vipIfm.discount)).toFixed(2) * Number(list[k].goodsNum)
          price6 += list[k].retailPrice * Number(list[k].goodsNum)
        }
        cartListTotalPrice1 = price1 + price2
        cartListTotalPrice3 = price5 + price6
      }
      console.log(price1, price2, "price2")
      console.log(cartListTotalPrice1, "cartListTotalPrice1")
      console.log(cartListTotalPrice3, "购物车总金额")
      console.log(list, "数量乘单价乘折扣不等于0.01或0.00的数组")
      for (var i in res) {
        if (res[i].memberPrice) {
          price3 += res[i].memberPrice * Number(res[i].goodsNum)
        } else {
          price4 += res[i].retailPrice * Number(res[i].goodsNum)
        }
      }
      cartListTotalPrice2 = price3 + price4
      console.log(cartListTotalPrice2, "等于0.01的和")
      state.cartListTotalPrice = (cartListTotalPrice1 + cartListTotalPrice2).toFixed(2)
      console.log(cartListTotalPrice9, "cartListTotalPrice9")
      state.cartListDiscounts = (cartListTotalPrice9 - state.cartListTotalPrice).toFixed(2)
    }
  },
  //销售员id存储
  add(state,n) {
    console.log(n)
    state.saleUserId = n
    // console.log(state.saleUserId)
  },
  // 收银开单扫码机录入开关s
  scanSwitch(state,n) {
    // console.log(state,n)
    state.scanSwitch = n
    localStorage.setItem('scanSwitchs', state.scanSwitch)
    console.log(state.scanSwitch, 'state.scanSwitch')
  },
  reduce(state) {
    state.count--;
  },
  changeShopInformation(state,data){
    console.log(data)
    state.shopInformation=data;
  }
}
export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js